import { render } from "./denounced-group-list.vue?vue&type=template&id=2f2bf813&ts=true"
import script from "./denounced-group-list.vue?vue&type=script&lang=ts"
export * from "./denounced-group-list.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__